import React from 'react';
import { Translation } from 'react-i18next';
import Resource from './Resource';

export default class Immunization extends Resource {
  get administeredAt(): String {
    return this.properties.administeredAt;
  }
  get title(): String {
    if (this.generated.title) {
      return this.generated.title;
    }
    return <Translation ns='immunization'>{(t) => t('title', { date: this.dateText })}</Translation>;
  }
  get institution_name() { // eslint-disable-line
    return this.properties.institution_name;
  }
  get reviewed(): boolean {
    return this.properties.reviewed;
  }
  get abbreviation(): String {
    return this.properties.name && this.properties.name.coding && this.properties.name.coding.code;
  }
}


// WEBPACK FOOTER //
// ./src/models/Immunization.js